// 上の帯：ロゴ・検索・言語の切り替え・ログイン（ログイン中は呼び名 → マイページ）。
import { onSession, session } from "../auth";
import { getLocale, localePath, onLocaleChange, t } from "../i18n";
import { openSignIn } from "./dialogs";
import { h } from "./dom";
import { getFilter, setFilter } from "./filter";
import { icon } from "./icons";

export function mountHeader(root: HTMLElement, navigate: (path: string) => void, switchLocale: () => void) {
  const logo = h("a", { class: "logo", href: "/" }, h("span", { class: "l1" }, "appful"), h("span", { class: "l2" }, "games"));
  const input = h("input", { type: "search", "data-testid": "search", autocomplete: "off", enterkeyhint: "search" });
  input.addEventListener("input", () => {
    // 一覧のほかの画面で打ち始めたら、一覧へ移って絞り込む
    const home = localePath("/");
    if (location.pathname !== home) navigate(home);
    setFilter({ q: input.value });
  });
  const search = h("label", { class: "search" }, icon("search"), input);
  const ja = h("span", {}, t("lang.ja"));
  const en = h("span", {}, t("lang.en"));
  const lang = h("button", { class: "lang", type: "button", "data-testid": "lang-switch", onclick: switchLocale }, ja, en);
  const user = h("a", { class: "btn-login", href: "/me/", "data-testid": "account-button" });
  user.addEventListener("click", (ev) => {
    if (session().user) return; // マイページへ（ページの切り替えは main.ts が受ける）
    ev.preventDefault();
    void openSignIn();
  });

  const render = () => {
    logo.setAttribute("href", localePath("/"));
    input.placeholder = t("search.placeholder");
    input.setAttribute("aria-label", t("search.placeholder"));
    if (input.value !== getFilter().q) input.value = getFilter().q;
    lang.setAttribute("aria-label", t("lang.switchAria"));
    ja.classList.toggle("on", getLocale() === "ja");
    en.classList.toggle("on", getLocale() === "en");
    const s = session();
    user.hidden = !s.ready;
    // ログイン中は人の絵と呼び名（スマホでは丸い人の絵だけ。呼び名は読み上げに渡す）
    if (s.user) user.replaceChildren(icon("user"), h("span", { class: "nm" }, s.displayName ?? "…"));
    else user.textContent = t("auth.signIn");
    if (s.user) user.setAttribute("aria-label", s.displayName ?? t("nav.me"));
    else user.removeAttribute("aria-label");
    user.classList.toggle("name", !!s.user);
    user.setAttribute("href", localePath("/me/"));
  };
  onSession(render);
  onLocaleChange(render);
  render();
  root.replaceChildren(h("div", { class: "hd-in" }, logo, search, lang, user));
}
